const Settings = () => {
    return (
        <div>
            <h1 style={{color: 'white'}}>Settings</h1>
        </div>
    )
};
export default Settings;